import {
  GET_QUOTATION,
  GET_QUOTATION_FAIL,
  GET_QUOTATION_SUCCESS,
  GET_QUOTATIONS,
  GET_QUOTATIONS_FAIL,
  GET_QUOTATIONS_SUCCESS,
  ADD_NEW_QUOTATION,
  ADD_QUOTATION_SUCCESS,
  ADD_QUOTATION_FAIL,
  UPDATE_QUOTATION,
  UPDATE_QUOTATION_SUCCESS,
  UPDATE_QUOTATION_FAIL,
  DELETE_QUOTATION,
  DELETE_QUOTATION_SUCCESS,
  DELETE_QUOTATION_FAIL,
  SET_STATE_QUOTATION,
  UPDATE_QUOTATION_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_QUOTATION,
  payload: loading,
})

export const getQuotations = ( params ) => ({
  type: GET_QUOTATIONS,
  payload: { params },
})

export const getQuotationsSuccess = (quotations, totalPages, currentPage) => ({
  type: GET_QUOTATIONS_SUCCESS,
  payload: { quotations:quotations, total:totalPages, currentPage:currentPage}
})

export const getQuotationsFail = error => ({
  type: GET_QUOTATIONS_FAIL,
  payload: error,
})

export const addNewQuotation = quotation => ({
  type: ADD_NEW_QUOTATION,
  payload: quotation,
})

export const addQuotationSuccess = quotation => ({
  type: ADD_QUOTATION_SUCCESS,
  payload: quotation,
})  

export const addQuotationFail = error => ({
  type: ADD_QUOTATION_FAIL,
  payload: error,
})

export const updateQuotation = quotation => ({
  type: UPDATE_QUOTATION,
  payload: quotation,
})

export const updateQuotationStatus = quotation => ({
  type: UPDATE_QUOTATION_STATUS,
  payload: quotation,
})

export const updateQuotationSuccess = quotation => ({
  type: UPDATE_QUOTATION_SUCCESS,
  payload: quotation,
})

export const updateQuotationFail = error => ({
  type: UPDATE_QUOTATION_FAIL,
  payload: error,
})

export const deleteQuotation = quotation => ({
  type: DELETE_QUOTATION,
  payload: quotation,
})

export const deleteQuotationSuccess = id => ({
  type: DELETE_QUOTATION_SUCCESS,
  id,
})

export const deleteQuotationFail = error => ({
  type: DELETE_QUOTATION_FAIL,
  payload: error,
})

export const getQuotation = () => ({
  type: GET_QUOTATION,
})

export const getQuotationSuccess = quotation => ({
  type: GET_QUOTATION_SUCCESS,
  payload: quotation,
})

export const getQuotationFail = error => ({
  type: GET_QUOTATION_FAIL,
  payload: error,
})
